<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  name: 'Project',
  mounted() {
    this.$store.dispatch('CurrentProject/fetch', { projectId: parseInt(this.$route.params.project_id, 10) });
  },
};
</script>
